export const mapToObj = (map) => {
  const obj = {};
  for (const [k, v] of map) {
    obj[k] = v;
  }
  return obj;
};

/**
 * 方便反填表单值时候转换
 * @param {*} obj
 * @returns
 */
export const mapNumToString = (obj) => {
  const newObj = {};
  for (let key in obj) {
    if (typeof obj[key] === 'number') {
      newObj[key] = obj[key] + '';
    } else {
      newObj[key] = obj[key];
    }
  }
  return newObj;
};
